export const LINK_PREVIEW_TYPE = 'LINK_PREVIEW';
